// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/booster/booster.proto (package guardianai.v1.booster, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/booster/booster.proto.
 */
export const file_guardianai_v1_booster_booster: GenFile = /*@__PURE__*/
  fileDesc("CiNndWFyZGlhbmFpL3YxL2Jvb3N0ZXIvYm9vc3Rlci5wcm90bxIVZ3VhcmRpYW5haS52MS5ib29zdGVyIo0CCg9Cb29zdGVyQ2FtcGFpZ24SCgoCaWQYASABKAkSDwoHdXNlcl9pZBgCIAEoCRIXCg9zdWJzY3JpcHRpb25faWQYAyABKAkSDgoGZW5naW5lGAQgASgJEg4KBnN0YXR1cxgFIAEoCRIZChFhc3NpZ25lZF9hZ2VudF9pZBgGIAEoCRIbChNhc3NpZ25lZF9hZ2VudF9uYW1lGAcgASgJEhcKD2FkX2J1ZGdldF9jZW50cxgIIAEoAxISCgpjcmVhdGVkX2F0GAkgASgJEhIKCnVwZGF0ZWRfYXQYCiABKAkSFAoMZm91bmRlcl9uYW1lGAsgASgJEhUKDWZvdW5kZXJfZW1haWwYDCABKAkiKQoXR2V0Qm9vc3RlclN0YXR1c1JlcXVlc3QSDgoGZW5naW5lGAEgASgJIlQKGEdldEJvb3N0ZXJTdGF0dXNSZXNwb25zZRI4CghjYW1wYWlnbhgBIAEoCzImLmd1YXJkaWFuYWkudjEuYm9vc3Rlci5Cb29zdGVyQ2FtcGFpZ24iUQobTGlzdEJvb3N0ZXJDYW1wYWlnbnNSZXF1ZXN0EhUKDXN0YXR1c19maWx0ZXIYASABKAkSDAoEcGFnZRgCIAEoBRINCgVsaW1pdBgDIAEoBSJuChxMaXN0Qm9vc3RlckNhbXBhaWduc1Jlc3BvbnNlEjkKCWNhbXBhaWducxgBIAMoCzImLmd1YXJkaWFuYWkudjEuYm9vc3Rlci5Cb29zdGVyQ2FtcGFpZ24SEwoLdG90YWxfY291bnQYAiABKAUiOwoSQXNzaWduQWdlbnRSZXF1ZXN0EhMKC2NhbXBhaWduX2lkGAEgASgJEhAKCGFnZW50X2lkGAIgASgJIk8KE0Fzc2lnbkFnZW50UmVzcG9uc2USOAoIY2FtcGFpZ24YASABKAsyJi5ndWFyZGlhbmFpLnYxLmJvb3N0ZXIuQm9vc3RlckNhbXBhaWduIi8KGEdldEZvdW5kZXJDb250ZXh0UmVxdWVzdBITCgtjYW1wYWlnbl9pZBgBIAEoCSKdAgoZR2V0Rm91bmRlckNvbnRleHRSZXNwb25zZRIOCgZlbmdpbmUYASABKAkSFAoMZm91bmRlcl9uYW1lGAIgASgJEhUKDWZvdW5kZXJfZW1haWwYAyABKAkSEgoKYnJhbmRfbmFtZRgKIAEoCRIQCghpbmR1c3RyeRgLIAEoCRIaChJ0YXJnZXRfZGVtb2dyYXBoaWMYDCABKAkSEwoLYnJhbmRfdm9pY2UYDSABKAkSFAoMY3VzdG9tX3J1bGVzGA4gAygJEhQKDGN1cnJlbnRfZ29hbBgPIAEoCRIdChVhdWRpZW5jZV9wcm9maWxlX2pzb24YFCABKAkSEAoIY2hhbm5lbHMYFSADKAkSDwoHcGVyc29uYRgWIAEoCTLkAwoOQm9vc3RlclNlcnZpY2UScwoQR2V0Qm9vc3RlclN0YXR1cxIuLmd1YXJkaWFuYWkudjEuYm9vc3Rlci5HZXRCb29zdGVyU3RhdHVzUmVxdWVzdBovLmd1YXJkaWFuYWkudjEuYm9vc3Rlci5HZXRCb29zdGVyU3RhdHVzUmVzcG9uc2USfwoUTGlzdEJvb3N0ZXJDYW1wYWlnbnMSMi5ndWFyZGlhbmFpLnYxLmJvb3N0ZXIuTGlzdEJvb3N0ZXJDYW1wYWlnbnNSZXF1ZXN0GjMuZ3VhcmRpYW5haS52MS5ib29zdGVyLkxpc3RCb29zdGVyQ2FtcGFpZ25zUmVzcG9uc2USZAoLQXNzaWduQWdlbnQSKS5ndWFyZGlhbmFpLnYxLmJvb3N0ZXIuQXNzaWduQWdlbnRSZXF1ZXN0GiouZ3VhcmRpYW5haS52MS5ib29zdGVyLkFzc2lnbkFnZW50UmVzcG9uc2USdgoRR2V0Rm91bmRlckNvbnRleHQSLy5ndWFyZGlhbmFpLnYxLmJvb3N0ZXIuR2V0Rm91bmRlckNvbnRleHRSZXF1ZXN0GjAuZ3VhcmRpYW5haS52MS5ib29zdGVyLkdldEZvdW5kZXJDb250ZXh0UmVzcG9uc2ViBnByb3RvMw");

/**
 * @generated from message guardianai.v1.booster.BoosterCampaign
 */
export type BoosterCampaign = Message<"guardianai.v1.booster.BoosterCampaign"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string subscription_id = 3;
   */
  subscriptionId: string;

  /**
   * "distro" | "caption"
   *
   * @generated from field: string engine = 4;
   */
  engine: string;

  /**
   * pending_initialization | awaiting_assignment | active | paused | completed
   *
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: string assigned_agent_id = 6;
   */
  assignedAgentId: string;

  /**
   * @generated from field: string assigned_agent_name = 7;
   */
  assignedAgentName: string;

  /**
   * @generated from field: int64 ad_budget_cents = 8;
   */
  adBudgetCents: bigint;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 10;
   */
  updatedAt: string;

  /**
   * @generated from field: string founder_name = 11;
   */
  founderName: string;

  /**
   * @generated from field: string founder_email = 12;
   */
  founderEmail: string;
};

/**
 * @generated from message guardianai.v1.booster.BoosterCampaign
 */
export type BoosterCampaignJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string subscription_id = 3;
   */
  subscriptionId?: string;

  /**
   * "distro" | "caption"
   *
   * @generated from field: string engine = 4;
   */
  engine?: string;

  /**
   * pending_initialization | awaiting_assignment | active | paused | completed
   *
   * @generated from field: string status = 5;
   */
  status?: string;

  /**
   * @generated from field: string assigned_agent_id = 6;
   */
  assignedAgentId?: string;

  /**
   * @generated from field: string assigned_agent_name = 7;
   */
  assignedAgentName?: string;

  /**
   * @generated from field: int64 ad_budget_cents = 8;
   */
  adBudgetCents?: string;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt?: string;

  /**
   * @generated from field: string updated_at = 10;
   */
  updatedAt?: string;

  /**
   * @generated from field: string founder_name = 11;
   */
  founderName?: string;

  /**
   * @generated from field: string founder_email = 12;
   */
  founderEmail?: string;
};

/**
 * Describes the message guardianai.v1.booster.BoosterCampaign.
 * Use `create(BoosterCampaignSchema)` to create a new message.
 */
export const BoosterCampaignSchema: GenMessage<BoosterCampaign, {jsonType: BoosterCampaignJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_booster_booster, 0);

/**
 * @generated from message guardianai.v1.booster.GetBoosterStatusRequest
 */
export type GetBoosterStatusRequest = Message<"guardianai.v1.booster.GetBoosterStatusRequest"> & {
  /**
   * "distro" | "caption"
   *
   * @generated from field: string engine = 1;
   */
  engine: string;
};

/**
 * @generated from message guardianai.v1.booster.GetBoosterStatusRequest
 */
export type GetBoosterStatusRequestJson = {
  /**
   * "distro" | "caption"
   *
   * @generated from field: string engine = 1;
   */
  engine?: string;
};

/**
 * Describes the message guardianai.v1.booster.GetBoosterStatusRequest.
 * Use `create(GetBoosterStatusRequestSchema)` to create a new message.
 */
export const GetBoosterStatusRequestSchema: GenMessage<GetBoosterStatusRequest, {jsonType: GetBoosterStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_booster_booster, 1);

/**
 * @generated from message guardianai.v1.booster.GetBoosterStatusResponse
 */
export type GetBoosterStatusResponse = Message<"guardianai.v1.booster.GetBoosterStatusResponse"> & {
  /**
   * null/empty if no booster campaign exists
   *
   * @generated from field: guardianai.v1.booster.BoosterCampaign campaign = 1;
   */
  campaign?: BoosterCampaign;
};

/**
 * @generated from message guardianai.v1.booster.GetBoosterStatusResponse
 */
export type GetBoosterStatusResponseJson = {
  /**
   * null/empty if no booster campaign exists
   *
   * @generated from field: guardianai.v1.booster.BoosterCampaign campaign = 1;
   */
  campaign?: BoosterCampaignJson;
};

/**
 * Describes the message guardianai.v1.booster.GetBoosterStatusResponse.
 * Use `create(GetBoosterStatusResponseSchema)` to create a new message.
 */
export const GetBoosterStatusResponseSchema: GenMessage<GetBoosterStatusResponse, {jsonType: GetBoosterStatusResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_booster_booster, 2);

/**
 * @generated from message guardianai.v1.booster.ListBoosterCampaignsRequest
 */
export type ListBoosterCampaignsRequest = Message<"guardianai.v1.booster.ListBoosterCampaignsRequest"> & {
  /**
   * optional: filter by status
   *
   * @generated from field: string status_filter = 1;
   */
  statusFilter: string;

  /**
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.booster.ListBoosterCampaignsRequest
 */
export type ListBoosterCampaignsRequestJson = {
  /**
   * optional: filter by status
   *
   * @generated from field: string status_filter = 1;
   */
  statusFilter?: string;

  /**
   * @generated from field: int32 page = 2;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.booster.ListBoosterCampaignsRequest.
 * Use `create(ListBoosterCampaignsRequestSchema)` to create a new message.
 */
export const ListBoosterCampaignsRequestSchema: GenMessage<ListBoosterCampaignsRequest, {jsonType: ListBoosterCampaignsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_booster_booster, 3);

/**
 * @generated from message guardianai.v1.booster.ListBoosterCampaignsResponse
 */
export type ListBoosterCampaignsResponse = Message<"guardianai.v1.booster.ListBoosterCampaignsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.booster.BoosterCampaign campaigns = 1;
   */
  campaigns: BoosterCampaign[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.booster.ListBoosterCampaignsResponse
 */
export type ListBoosterCampaignsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.booster.BoosterCampaign campaigns = 1;
   */
  campaigns?: BoosterCampaignJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.booster.ListBoosterCampaignsResponse.
 * Use `create(ListBoosterCampaignsResponseSchema)` to create a new message.
 */
export const ListBoosterCampaignsResponseSchema: GenMessage<ListBoosterCampaignsResponse, {jsonType: ListBoosterCampaignsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_booster_booster, 4);

/**
 * @generated from message guardianai.v1.booster.AssignAgentRequest
 */
export type AssignAgentRequest = Message<"guardianai.v1.booster.AssignAgentRequest"> & {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId: string;

  /**
   * @generated from field: string agent_id = 2;
   */
  agentId: string;
};

/**
 * @generated from message guardianai.v1.booster.AssignAgentRequest
 */
export type AssignAgentRequestJson = {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId?: string;

  /**
   * @generated from field: string agent_id = 2;
   */
  agentId?: string;
};

/**
 * Describes the message guardianai.v1.booster.AssignAgentRequest.
 * Use `create(AssignAgentRequestSchema)` to create a new message.
 */
export const AssignAgentRequestSchema: GenMessage<AssignAgentRequest, {jsonType: AssignAgentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_booster_booster, 5);

/**
 * @generated from message guardianai.v1.booster.AssignAgentResponse
 */
export type AssignAgentResponse = Message<"guardianai.v1.booster.AssignAgentResponse"> & {
  /**
   * @generated from field: guardianai.v1.booster.BoosterCampaign campaign = 1;
   */
  campaign?: BoosterCampaign;
};

/**
 * @generated from message guardianai.v1.booster.AssignAgentResponse
 */
export type AssignAgentResponseJson = {
  /**
   * @generated from field: guardianai.v1.booster.BoosterCampaign campaign = 1;
   */
  campaign?: BoosterCampaignJson;
};

/**
 * Describes the message guardianai.v1.booster.AssignAgentResponse.
 * Use `create(AssignAgentResponseSchema)` to create a new message.
 */
export const AssignAgentResponseSchema: GenMessage<AssignAgentResponse, {jsonType: AssignAgentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_booster_booster, 6);

/**
 * @generated from message guardianai.v1.booster.GetFounderContextRequest
 */
export type GetFounderContextRequest = Message<"guardianai.v1.booster.GetFounderContextRequest"> & {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId: string;
};

/**
 * @generated from message guardianai.v1.booster.GetFounderContextRequest
 */
export type GetFounderContextRequestJson = {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId?: string;
};

/**
 * Describes the message guardianai.v1.booster.GetFounderContextRequest.
 * Use `create(GetFounderContextRequestSchema)` to create a new message.
 */
export const GetFounderContextRequestSchema: GenMessage<GetFounderContextRequest, {jsonType: GetFounderContextRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_booster_booster, 7);

/**
 * @generated from message guardianai.v1.booster.GetFounderContextResponse
 */
export type GetFounderContextResponse = Message<"guardianai.v1.booster.GetFounderContextResponse"> & {
  /**
   * @generated from field: string engine = 1;
   */
  engine: string;

  /**
   * @generated from field: string founder_name = 2;
   */
  founderName: string;

  /**
   * @generated from field: string founder_email = 3;
   */
  founderEmail: string;

  /**
   * For CaptionEngine campaigns — the Business Profile
   *
   * @generated from field: string brand_name = 10;
   */
  brandName: string;

  /**
   * @generated from field: string industry = 11;
   */
  industry: string;

  /**
   * @generated from field: string target_demographic = 12;
   */
  targetDemographic: string;

  /**
   * @generated from field: string brand_voice = 13;
   */
  brandVoice: string;

  /**
   * @generated from field: repeated string custom_rules = 14;
   */
  customRules: string[];

  /**
   * @generated from field: string current_goal = 15;
   */
  currentGoal: string;

  /**
   * For DistroEngine campaigns — the Audience Profile
   *
   * @generated from field: string audience_profile_json = 20;
   */
  audienceProfileJson: string;

  /**
   * @generated from field: repeated string channels = 21;
   */
  channels: string[];

  /**
   * @generated from field: string persona = 22;
   */
  persona: string;
};

/**
 * @generated from message guardianai.v1.booster.GetFounderContextResponse
 */
export type GetFounderContextResponseJson = {
  /**
   * @generated from field: string engine = 1;
   */
  engine?: string;

  /**
   * @generated from field: string founder_name = 2;
   */
  founderName?: string;

  /**
   * @generated from field: string founder_email = 3;
   */
  founderEmail?: string;

  /**
   * For CaptionEngine campaigns — the Business Profile
   *
   * @generated from field: string brand_name = 10;
   */
  brandName?: string;

  /**
   * @generated from field: string industry = 11;
   */
  industry?: string;

  /**
   * @generated from field: string target_demographic = 12;
   */
  targetDemographic?: string;

  /**
   * @generated from field: string brand_voice = 13;
   */
  brandVoice?: string;

  /**
   * @generated from field: repeated string custom_rules = 14;
   */
  customRules?: string[];

  /**
   * @generated from field: string current_goal = 15;
   */
  currentGoal?: string;

  /**
   * For DistroEngine campaigns — the Audience Profile
   *
   * @generated from field: string audience_profile_json = 20;
   */
  audienceProfileJson?: string;

  /**
   * @generated from field: repeated string channels = 21;
   */
  channels?: string[];

  /**
   * @generated from field: string persona = 22;
   */
  persona?: string;
};

/**
 * Describes the message guardianai.v1.booster.GetFounderContextResponse.
 * Use `create(GetFounderContextResponseSchema)` to create a new message.
 */
export const GetFounderContextResponseSchema: GenMessage<GetFounderContextResponse, {jsonType: GetFounderContextResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_booster_booster, 8);

/**
 * BoosterService provides campaign management for Managed Growth / Managed Brand packages.
 *
 * @generated from service guardianai.v1.booster.BoosterService
 */
export const BoosterService: GenService<{
  /**
   * Founder: get their booster campaign status for a given engine
   *
   * @generated from rpc guardianai.v1.booster.BoosterService.GetBoosterStatus
   */
  getBoosterStatus: {
    methodKind: "unary";
    input: typeof GetBoosterStatusRequestSchema;
    output: typeof GetBoosterStatusResponseSchema;
  },
  /**
   * Admin: list all booster campaigns across founders
   *
   * @generated from rpc guardianai.v1.booster.BoosterService.ListBoosterCampaigns
   */
  listBoosterCampaigns: {
    methodKind: "unary";
    input: typeof ListBoosterCampaignsRequestSchema;
    output: typeof ListBoosterCampaignsResponseSchema;
  },
  /**
   * Admin: assign a sales agent to a booster campaign
   *
   * @generated from rpc guardianai.v1.booster.BoosterService.AssignAgent
   */
  assignAgent: {
    methodKind: "unary";
    input: typeof AssignAgentRequestSchema;
    output: typeof AssignAgentResponseSchema;
  },
  /**
   * Agent: get the founder's brand context for a campaign they are assigned to
   *
   * @generated from rpc guardianai.v1.booster.BoosterService.GetFounderContext
   */
  getFounderContext: {
    methodKind: "unary";
    input: typeof GetFounderContextRequestSchema;
    output: typeof GetFounderContextResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_booster_booster, 0);

